/* global ADV */

// ------------------------------------------------------
// 
// 
// 
//      OUT DATED, use formatNumber.ts instead
// 
// 
// 
// 
// ------------------------------------------------------
import isNil from 'lodash/isNil';

export default (number) => {
  if (isNil(number)) {
    return '';
  }

  const sign = number < 0 ? '-' : '';
  const value = ADV.util.number_format(Math.abs(number), 0);

  return `${sign}$${value}`;
};
